export default __webpack_public_path__ + "static/media/illus_2FA_3.03a124b1.svg";